import React, { Component } from "react";
import PropTypes from "prop-types";
import { messages } from "../../../i18n-messages";
import {
    Bucket,
    BucketHeader,
    Checkbox,
    NumericInput,
    Section,
    SelectInput,
    SubSection,
    TextInput,
} from "~/core";
import { model } from "../../data";
import { adminData, GUID, NAME, PICKLIST_GUID, VALUE } from "~/admin/data";
import * as unitService from "~/core/units/unit-names";
import * as picklistService from "~/core/picklist/picklist-names";
import { mapToPicklistValue, prepareSelectableOptions } from "~/admin/utils";

export default class Irrigation extends Component {
    static propTypes = {
        formatMessage: PropTypes.func,
        onSelectInputChange: PropTypes.func,
        onTextChange: PropTypes.func,
        onNumberChange: PropTypes.func,
        equipmentSetup: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = {
            [unitService.UNIT_LENGTH]: prepareSelectableOptions(props[unitService.UNIT_LENGTH], {
                guid: GUID,
                label: NAME,
            }),
            [unitService.UNIT_FLOW_RATE]: prepareSelectableOptions(
                props[unitService.UNIT_FLOW_RATE],
                { guid: GUID, label: NAME }
            ),
            [picklistService.PICKLIST_WELL_TYPE]: prepareSelectableOptions(
                props[picklistService.PICKLIST_WELL_TYPE],
                { guid: PICKLIST_GUID, label: VALUE }
            ),
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.initializeUnitLength(nextProps);
        this.initializeUnitFlowRate(nextProps);
        this.initializePicklistWellType(nextProps);
    }

    initializeUnitLength = (nextProps) => {
        if (nextProps[unitService.UNIT_LENGTH] !== this.props[unitService.UNIT_LENGTH]) {
            this.setState({
                [unitService.UNIT_LENGTH]: prepareSelectableOptions(
                    nextProps[unitService.UNIT_LENGTH],
                    { guid: GUID, label: NAME }
                ),
            });
        }
    };

    initializeUnitFlowRate = (nextProps) => {
        if (nextProps[unitService.UNIT_FLOW_RATE] !== this.props[unitService.UNIT_FLOW_RATE]) {
            this.setState({
                [unitService.UNIT_FLOW_RATE]: prepareSelectableOptions(
                    nextProps[unitService.UNIT_FLOW_RATE],
                    { guid: GUID, label: NAME }
                ),
            });
        }
    };

    initializePicklistWellType = (nextProps) => {
        if (
            nextProps[picklistService.PICKLIST_WELL_TYPE] !==
            this.props[picklistService.PICKLIST_WELL_TYPE]
        ) {
            this.setState({
                [picklistService.PICKLIST_WELL_TYPE]: prepareSelectableOptions(
                    nextProps[picklistService.PICKLIST_WELL_TYPE],
                    { guid: PICKLIST_GUID, label: VALUE }
                ),
            });
        }
    };

    render() {
        const { formatMessage, equipmentSetup, onSelectInputChange, onTextChange, onNumberChange } =
            this.props;
        return (
            <Bucket
                className="form-section-bucket purchase-history"
                showSymbol={true}
                isCollapsible={true}
                isExpanded={false}
                testId="equipment-irrigation-bucket"
            >
                <BucketHeader>{formatMessage(messages.irrigation)}</BucketHeader>
                <Section testId="equipment-irrigation-section">
                    <SubSection testId="equipment-irrigation-fertigation-subsection">
                        <Checkbox
                            onChange={(e, value) => onTextChange(model.PROPS_FERTIGATION, value)}
                            value={equipmentSetup[model.PROPS_FERTIGATION]}
                            label={formatMessage(messages.fertigation)}
                            testId="equipment-irrigation-fertigation-checkbox"
                        />
                        <Checkbox
                            onChange={(e, value) => onTextChange(model.PROPS_CHEMIGATION, value)}
                            value={equipmentSetup[model.PROPS_CHEMIGATION]}
                            label={formatMessage(messages.chemigation)}
                            testId="equipment-irrigation-chemigation-checkbox"
                        />
                    </SubSection>
                    <SubSection testId="equipment-irrigation-sprinklers-pivot-subsection">
                        <NumericInput
                            scale={0}
                            precision={4}
                            onChange={(value) =>
                                onNumberChange(model.PROPS_NUMBER_OF_SPRINKLERS, value)
                            }
                            value={equipmentSetup[model.PROPS_NUMBER_OF_SPRINKLERS]}
                            placeholderText={formatMessage(messages.numberOfSprinklers)}
                            testId="equipment-irrigation-number-of-sprinklers-input"
                        />
                        <NumericInput
                            scale={2}
                            precision={9}
                            onChange={(value) => onNumberChange(model.PROPS_PIVOT_SIZE, value)}
                            value={equipmentSetup[model.PROPS_PIVOT_SIZE]}
                            placeholderText={formatMessage(messages.pivotSize)}
                            testId="equipment-irrigation-pivot-size-input"
                        />
                    </SubSection>
                    <SubSection testId="equipment-irrigation-pivot-unit-tubing-subsection">
                        <SelectInput
                            optionIsHiddenKey={adminData.PROPS_ACTIVE_YN}
                            placeholderText={formatMessage(messages.pivotSizeUnit)}
                            options={this.state[unitService.UNIT_LENGTH]}
                            value={mapToPicklistValue({
                                options: this.state[unitService.UNIT_LENGTH],
                                selectedGuid: equipmentSetup[model.PROPS_PIVOT_SIZE_UNIT_GUID],
                            })}
                            onChange={(value) => {
                                onSelectInputChange(
                                    { guid: model.PROPS_PIVOT_SIZE_UNIT_GUID },
                                    value
                                );
                            }}
                            testId="equipment-irrigation-pivot-size-unit-select"
                        />
                        <NumericInput
                            scale={2}
                            precision={9}
                            onChange={(value) => onNumberChange(model.PROPS_TUBING_SIZE, value)}
                            value={equipmentSetup[model.PROPS_TUBING_SIZE]}
                            placeholderText={formatMessage(messages.tubingSize)}
                            testId="equipment-irrigation-tubing-size-input"
                        />
                    </SubSection>
                    <SubSection testId="equipment-irrigation-tubing-unit-well-subsection">
                        <SelectInput
                            optionIsHiddenKey={adminData.PROPS_ACTIVE_YN}
                            placeholderText={formatMessage(messages.tubingSizeUnit)}
                            options={this.state[unitService.UNIT_LENGTH]}
                            value={mapToPicklistValue({
                                options: this.state[unitService.UNIT_LENGTH],
                                selectedGuid: equipmentSetup[model.PROPS_TUBING_SIZE_UNIT_GUID],
                            })}
                            onChange={(value) => {
                                onSelectInputChange(
                                    { guid: model.PROPS_TUBING_SIZE_UNIT_GUID },
                                    value
                                );
                            }}
                            testId="equipment-irrigation-tubing-size-unit-select"
                        />
                        <TextInput
                            value={equipmentSetup[model.PROPS_WELL]}
                            placeholderText={formatMessage(messages.well)}
                            onChange={(value) => {
                                onTextChange(model.PROPS_WELL, value);
                            }}
                            testId="equipment-irrigation-well-input"
                        />
                    </SubSection>
                    <SubSection testId="equipment-irrigation-well-depth-subsection">
                        <NumericInput
                            scale={2}
                            precision={9}
                            onChange={(value) => onNumberChange(model.PROPS_WELL_DEPTH, value)}
                            value={equipmentSetup[model.PROPS_WELL_DEPTH]}
                            placeholderText={formatMessage(messages.depth)}
                            testId="equipment-irrigation-well-depth-input"
                        />
                        <SelectInput
                            optionIsHiddenKey={adminData.PROPS_ACTIVE_YN}
                            placeholderText={formatMessage(messages.depthUnit)}
                            options={this.state[unitService.UNIT_LENGTH]}
                            value={mapToPicklistValue({
                                options: this.state[unitService.UNIT_LENGTH],
                                selectedGuid: equipmentSetup[model.PROPS_WELL_DEPTH_UNIT_GUID],
                            })}
                            onChange={(value) => {
                                onSelectInputChange(
                                    { guid: model.PROPS_WELL_DEPTH_UNIT_GUID },
                                    value
                                );
                            }}
                            testId="equipment-irrigation-well-depth-unit-select"
                        />
                    </SubSection>
                    <SubSection testId="equipment-irrigation-well-type-output-subsection">
                        <SelectInput
                            optionIsHiddenKey={adminData.PROPS_ACTIVE_YN}
                            placeholderText={formatMessage(messages.wellType)}
                            options={this.state[picklistService.PICKLIST_WELL_TYPE]}
                            value={mapToPicklistValue({
                                options: this.state[picklistService.PICKLIST_WELL_TYPE],
                                selectedGuid: equipmentSetup[model.PROPS_WELL_TYPE_GUID],
                            })}
                            onChange={(value) => {
                                onSelectInputChange({ guid: model.PROPS_WELL_TYPE_GUID }, value);
                            }}
                            testId="equipment-irrigation-well-type-select"
                        />
                        <NumericInput
                            scale={2}
                            precision={9}
                            onChange={(value) => onNumberChange(model.PROPS_WELL_OUTPUT, value)}
                            value={equipmentSetup[model.PROPS_WELL_OUTPUT]}
                            placeholderText={formatMessage(messages.wellOutput)}
                            testId="equipment-irrigation-well-output-input"
                        />
                    </SubSection>
                    <SubSection testId="equipment-irrigation-well-output-unit-subsection">
                        <SelectInput
                            optionIsHiddenKey={adminData.PROPS_ACTIVE_YN}
                            placeholderText={formatMessage(messages.wellOutputUnit)}
                            options={this.state[unitService.UNIT_FLOW_RATE]}
                            value={mapToPicklistValue({
                                options: this.state[unitService.UNIT_FLOW_RATE],
                                selectedGuid: equipmentSetup[model.PROPS_WELL_OUTPUT_UNIT_GUID],
                            })}
                            onChange={(value) => {
                                onSelectInputChange(
                                    { guid: model.PROPS_WELL_OUTPUT_UNIT_GUID },
                                    value
                                );
                            }}
                            testId="equipment-irrigation-well-output-unit-select"
                        />
                    </SubSection>
                </Section>
            </Bucket>
        );
    }
}
